import { signIn } from '@/lib/auth';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useState } from 'react';

export const Route = createFileRoute('/login')({
  component: LoginPage,
});

function LoginPage() {
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setPending(true);
    try {
      const { error: err } = await signIn.email({ email, password });
      if (err) {
        setError(err.message ?? 'Login failed');
        return;
      }
      router.navigate({ to: '/dashboard' });
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="login-split">
      {/* Brand panel — mirrors the public site's auth split so the admin login reads as the same product. */}
      <aside className="login-brand">
        <div>
          <div className="display" style={{ fontSize: 22, color: '#fff' }}>
            LEVAMAR
          </div>
          <div className="label" style={{ color: 'var(--lv-brand-glow)', fontSize: 9, marginTop: 2 }}>
            ADMIN PANEL
          </div>
        </div>
        <h1 className="display login-brand-title">
          FROTA.
          <br />
          RESERVAS.
          <br />
          <span style={{ color: 'var(--lv-brand-light)' }}>NA MÃO.</span>
        </h1>
        <div className="login-brand-foot">
          <span>SANTO ANTÃO · CABO VERDE</span>
        </div>
      </aside>

      <div className="login-form-col">
        <form
          onSubmit={onSubmit}
          style={{
            width: '100%',
            maxWidth: 400,
            background: '#fff',
            border: '1px solid var(--lv-line)',
            padding: 32,
          }}
        >
          <div className="display" style={{ fontSize: 26 }}>
            ADMIN
          </div>
          <div className="label" style={{ color: 'var(--lv-brand)', marginTop: 4 }}>
            Levamar Rent-A-Car
          </div>
          <span
            style={{
              display: 'block',
              width: 48,
              height: 4,
              background: 'var(--lv-brand)',
              margin: '16px 0 24px',
            }}
          />

          <label style={{ display: 'block', marginBottom: 12 }}>
            <span className="label" style={{ color: 'var(--lv-gray-500)' }}>
              Email
            </span>
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                marginTop: 4,
                width: '100%',
                padding: '10px 12px',
                border: '1px solid var(--lv-line)',
                background: '#fff',
              }}
            />
          </label>

          <label style={{ display: 'block', marginBottom: 16 }}>
            <span className="label" style={{ color: 'var(--lv-gray-500)' }}>
              Palavra-passe
            </span>
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                marginTop: 4,
                width: '100%',
                padding: '10px 12px',
                border: '1px solid var(--lv-line)',
                background: '#fff',
              }}
            />
          </label>

          {error && (
            <div
              style={{
                background: '#fce4e4',
                color: 'var(--lv-err)',
                border: '1px solid #f2c0c0',
                padding: '8px 12px',
                fontSize: 13,
                marginBottom: 16,
              }}
              role="alert"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={pending}
            style={{
              display: 'inline-flex',
              justifyContent: 'center',
              width: '100%',
              padding: '14px 22px',
              background: 'var(--lv-brand)',
              color: '#fff',
              border: 0,
              fontWeight: 700,
              opacity: pending ? 0.6 : 1,
            }}
          >
            {pending ? '…' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
